/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FloorsLettingAttribute
 */
export interface FloorsLettingAttribute {
    /**
     * 
     * @type {string}
     * @memberof FloorsLettingAttribute
     */
    valueOriginal?: string;
    /**
     * 
     * @type {number}
     * @memberof FloorsLettingAttribute
     */
    attributeId: number;
    /**
     * 
     * @type {number}
     * @memberof FloorsLettingAttribute
     */
    floorsFrom?: number;
    /**
     * 
     * @type {number}
     * @memberof FloorsLettingAttribute
     */
    floorsTo?: number;
    /**
     * 
     * @type {string}
     * @memberof FloorsLettingAttribute
     */
    valueInterpretationStatusCode: string;
    /**
     * 
     * @type {string}
     * @memberof FloorsLettingAttribute
     */
    valueInterpretationMessage: string;
}

export function FloorsLettingAttributeFromJSON(json: any): FloorsLettingAttribute {
    return FloorsLettingAttributeFromJSONTyped(json, false);
}

export function FloorsLettingAttributeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FloorsLettingAttribute {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'valueOriginal': !exists(json, 'valueOriginal') ? undefined : json['valueOriginal'],
        'attributeId': json['attributeId'],
        'floorsFrom': !exists(json, 'floorsFrom') ? undefined : json['floorsFrom'],
        'floorsTo': !exists(json, 'floorsTo') ? undefined : json['floorsTo'],
        'valueInterpretationStatusCode': json['valueInterpretationStatusCode'],
        'valueInterpretationMessage': json['valueInterpretationMessage'],
    };
}

export function FloorsLettingAttributeToJSON(value?: FloorsLettingAttribute | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'valueOriginal': value.valueOriginal,
        'attributeId': value.attributeId,
        'floorsFrom': value.floorsFrom,
        'floorsTo': value.floorsTo,
        'valueInterpretationStatusCode': value.valueInterpretationStatusCode,
        'valueInterpretationMessage': value.valueInterpretationMessage,
    };
}


